<template>
    <OverlayLoader :isLoading="!isLoaded">
        <main class="page page-dashboard">
            <div class="container">

                <PageHeader
                    :title="`${this.$translate.text('clients.connections.edit')} ( ${items.connection.name} )`"
                />

                <ConnectionMenu></ConnectionMenu>
                <div v-if="items.connection.webshop_type === 'magento'">
                    <Alert>{{ t('alert.combine.brands.magento') }}</Alert>
                </div>
                <div v-else-if="items.connection.webshop_type === 'woocommerce'">
                    <Alert>{{ t('alert.combine.brands.woocommerce') }}</Alert>
                </div>
                <div v-else>
                    <form @submit.prevent="submitForm" method="POST">
                        <div class="row">
                            <div class="col-sm-3">
                                <h4>{{ t('clients.connections.categories.combine') }}</h4>
                            </div>
                            <div class="col-sm"></div>
                            <div class="col-sm">
                                <h4>{{ t('clients.connections.categories.draganddrop') }}</h4>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-8" style="display:flex; overflow: auto; height: 700px; padding: 0px;">
                                <div class="col-sm-6">

                                    <input type="text" v-model="search_combinable" class="form-input" placeholder="Zoeken..." style="  height: 37px; width: 100%; border: none; border-radius: 4px; padding: 8px; margin-top: 10px;" />

                                    <div
                                        v-for="(item, index) in combinableValues"
                                        :key="`labels-${index}`"
                                        style="margin-top: 10px;"
                                    >
                                        <div
                                            v-for="(n,index_number) in item.depth"
                                            :key="index_number"
                                            :style="{
                                                'marginLeft': `${index_number * 10}px`,
                                                'height': `${(37 * item.placeholders.length) + (10 * (item.placeholders.length-1)) + (calulateExtraMargin(index_number, item.depth))}px`,
                                            }"
                                            class="depth-line"
                                        >
                                        </div>
                                        <div

                                            class="list-group-item list-group-item--header list-group-item--header--with-placeholders n-m-t ellipsis"
                                            :style="{
                                                'height': `${(37 * item.placeholders.length) + (10 * (item.placeholders.length-1))}px`,
                                                'marginLeft': `${10 * item.depth}px`,
                                                'backgroundColor': `rgb(160, 179, 196,${calculateBackground(item.depth)})`,
                                            }"
                                        >
                                            <p class="n-p m-w-190 ellipsis" v-tooltip.bottom="item.name" style="float:left;">{{ item.name }}</p>
                                            <i class="fal fa-plus pointer" v-if="item.value !== '' && mode === 'combine'" style="float:right; margin-left: 10px;" @click="appendPlaceholder(index)" v-tooltip.bottom="$translate.text('tooltip.append')"></i>
                                            <i class="fal fa-trash-alt pointer" v-if="mode === 'edit'" style="float:right; margin-left: 10px;" @click="deleteWebshopItem(index, item)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                                            <!-- <i class="fal fa-stream pointer" v-if="mode === 'edit'" style="float:right; margin-left: 10px;" @click="appendWebshopItem(index, item.depth)"></i> -->
                                            <i class="fal fa-edit pointer" v-if="mode === 'edit'" style="float:right; margin-left: 10px;" @click="editWebshopItem(item)" v-tooltip.bottom="$translate.text('tooltip.edit')"></i>
                                        </div>
                                    </div>

                                </div>

                                <div class="col-sm">

                                    <div style="height: 47px;">&nbsp;</div>

                                    <template v-for="(item, itemIndex) in combinableValues">
                                        <drop
                                            class="drop list-group-item list-group-item--drop no-select"
                                            v-for="(placeholder, placeholderIndex) in item.placeholders"
                                            :key="`labels-${itemIndex}-placeholders-${placeholderIndex}`"
                                            :class="{'list-group-item--targeted': placeholder.hovered, 'list-group-item--holder': placeholder.value === '', 'list-group-item--drop--disabled': mode === 'edit'}"
                                            @drop="dropHandle($event, itemIndex, placeholderIndex)"
                                            @dragenter="dragEnter(itemIndex, placeholderIndex)"
                                            @dragleave="dragLeave(itemIndex, placeholderIndex)"
                                        >
                                            {{ placeholder.value }}
                                            <i class="fal fa-trash-alt pointer" v-if="placeholder.value !== '' && mode === 'combine'" style="float:right;" @click="dropClear(itemIndex, placeholderIndex)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                                        </drop>
                                    </template>
                                </div>


                            </div>

                            <div class="col-sm" style="overflow: auto; height: 700px;">

                                <input type="text" v-model="search" class="form-input" placeholder="Zoeken..." style="  height: 37px; width: 100%; border: none; border-radius: 4px; padding: 8px; margin-top: 10px;" />

                                <drag
                                    class="drag list-group-item list-group-item--drag no-select"
                                    v-for="(item, index) in uncombinedValues"
                                    :key="`values-${index}`"
                                    :transfer-data="item"
                                    :draggable="mode === 'combine'"
                                    :class="{'list-group-item--drag--disabled': mode === 'edit'}"
                                >
                                    <i class="fal fa-arrows"></i> {{ item }}
                                </drag>
                            </div>

                        </div>
                        <div class="col-sm-4">
                            <div class="list-group-item list-group-item--action" v-if="mode === 'edit'" @click="appendWebshopItem()" >
                                <i class="fal fa-plus pointer"></i>
                                {{ t('clients.connections.brands.add') }}
                            </div>
                            <div class="list-group-item list-group-item--action list-group-item--action--save" @click="changeMode('combine')" v-if="mode === 'edit'">
                                <i class="fal fa-edit pointer"></i>
                                {{ t('clients.connections.categories.mode.combine') }}
                            </div>

                            <div class="list-group-item list-group-item--action" @click="changeMode('edit')" v-if="mode === 'combine'">
                                <i class="fal fa-edit pointer"></i>
                                {{ t('clients.connections.categories.mode.edit') }}
                            </div>
                        </div>

                        <div class="col-sm-12">
                            <FormSubmit
                                :routeAfterCancelLink="{ name: 'Clients Connections' }"
                                :buttonLabel="loaded.submit ? $translate.text('general.save.saving') :  $translate.text('general.save')"
                                :disabled="loaded.submit"
                            />
                        </div>

                    </form>
                </div>

            </div>
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';

import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';

import Alert from '@/components/Alert/Alert';
import PageHeader from '@/components/PageHeader/PageHeader';
import FormSubmit from '@/components/Forms/FormSubmit';
import handleError from '@/helpers/error';

import ConnectionMenu from '@/components/ConnectionMenu/ConnectionMenu';

export default {
    name: 'CombineBrands',

    components: {
        ConnectionMenu,
        PageHeader,
        FormSubmit,
        OverlayLoader,
        Alert,
    },

    data() {
        return {

            search_combinable: '',
            search: '',

            items: {
                webshop: [],
                feed: [],
                connection: [],
            },

            loaded: {
                items: {
                    webshop: false,
                    feed: false,
                    combined: false,
                    connection: false,
                },
                submit: false,
            },

            mode: 'combine',
        };
    },

    created() {
        this.getItems();
    },

    methods: {
        calculateBackground(depth) {
            const number = 10;
            const finalNumber = number - (depth * 2);

            if (depth === 0) {
                return '1.0';
            }
            if (depth === 5) {
                return '0.2';
            }

            return `0.${finalNumber}`;
        },

        calulateExtraMargin(index, depth) {
            // function to return the amout of margin top. its either 10 or 0
            if ((index + 1) === depth) {
                return 0;
            }
            return 10;
        },

        getItems() {
            this.getItemsFromWebshop();
            this.getItemsFromFeed();
            this.getConnection();
        },

        getConnection() {
            this.API.clients.connections.show(this.$route.params.id)
                .then(response => {
                    this.items.connection = response.data.data;
                    this.loaded.items.connection = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getItemsFromWebshop() {
            this.API.clients.connections.brands.getItemsFromWebshop(this.$route.params.id)
                .then(response => {
                    this.items.webshop = response.data.map(item => {
                        item.placeholders = [
                            {
                                hovered: false,
                                value: '',
                            },
                        ];

                        return item;
                    });

                    this.loaded.items.webshop = true;

                    this.getCombined();
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getItemsFromFeed() {
            this.API.clients.connections.brands.getItemsFromFeed(this.$route.params.id)
                .then(response => {
                    this.items.feed = response.data;
                    this.loaded.items.feed = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCombined() {
            this.API.clients.connections.brands.getCombined(this.$route.params.id)
                .then(response => {
                    response.data.data.forEach(combined => {
                        this.items.webshop.map(item => {
                            if (`${item.id}` === combined.webshop_id) {
                                if (item.placeholders[0].value === '') {
                                    item.placeholders[0].value = combined.feed_name;
                                } else {
                                    item.placeholders.push({
                                        hovered: false,
                                        value: combined.feed_name,
                                    });
                                }
                            }

                            return item;
                        });
                    });

                    this.loaded.items.combined = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        appendPlaceholder(index) {
            this.combinableValues[index].placeholders.push({
                hovered: false,
                value: '',
            });
        },

        // appendWebshopItem() {
        //     swal({
        //         title: this.$translate.text('clients.connections.brands.add.name'),
        //         content: 'input',
        //     }).then(name => {
        //         if (name.length > 0) {
        //             this.items.webshop.push({
        //                 id: null,
        //                 name,
        //                 placeholders: [
        //                     {
        //                         hovered: false,
        //                         value: '',
        //                     },
        //                 ],
        //             });
        //         }
        //     });
        // },

        appendWebshopItem(atIndex = null) {
            const item = {
                id: null,
                name: '',
                placeholders: [
                    {
                        hovered: false,
                        value: '',
                    },
                ],
            };

            swal({
                cancel: true,
                title: this.$translate.text('clients.connections.brands.add.name'),
                content: 'input',
            }).then(name => {
                if (name.length > 0) {
                    item.name = name;

                    this.API.clients.connections.brands.createItemsInWebshop(this.$route.params.id, {
                        name: item.name,
                    }).then(response => {
                        item.id = response.data.id;

                        if (atIndex !== null) {
                            this.items.webshop.splice(atIndex + 1, 0, item);
                        } else {
                            this.items.webshop.push(item);
                        }

                        swal({
                            title: this.$translate.text('alert.success'),
                            text: this.$translate.text('alert.success.message.saved'),
                        });
                    })
                        .catch(error => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },

        editWebshopItem(item) {
            swal({
                title: this.$translate.text('clients.connections.brands.edit.name'),
                content: {
                    element: 'input',
                    attributes: {
                        value: item.name,
                    },

                },
                buttons: {
                    cancel: this.$translate.text('general.cancel'),
                    confirm: this.$translate.text('general.save'),
                },
            }).then(name => {
                if (name.length > 0) {
                    if (item.id !== null) {
                        this.API.clients.connections.brands.updateItemInWebshop(this.$route.params.id, item.id, {
                            name,
                        })
                            .then(() => {
                                item.name = name;

                                swal({
                                    title: this.$translate.text('alert.success'),
                                    text: this.$translate.text('alert.success.message.saved'),
                                });
                            })
                            .catch(error => {
                                handleError({
                                    error,
                                    message: this.$translate.text('alert.whoops'),
                                });
                            });
                    } else {
                        item.name = name;
                    }
                }
            });
        },

        deleteWebshopItem(index, item) {
            swal({
                title: this.$translate.text('alert.confirm.delete'),
                buttons: {
                    cancel: this.$translate.text('general.no'),
                    confirm: this.$translate.text('general.yes'),
                },
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.API.clients.connections.brands.deleteItemInWebshop(this.$route.params.id, item.id)
                            .then(() => {
                                this.items.webshop.splice(index, 1);

                                swal({
                                    title: this.$translate.text('alert.success'),
                                    text: this.$translate.text('alert.success.message.saved'),
                                });
                            })
                            .catch(error => {
                                handleError({
                                    error,
                                    message: this.$translate.text('alert.whoops'),
                                });
                            });
                    }
                });
        },

        changeMode(mode) {
            this.mode = mode;
        },

        dropHandle(data, itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].hovered = false;
            this.combinableValues[itemIndex].placeholders[placeholderIndex].value = data;
        },

        dropClear(itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].value = '';
        },

        dragEnter(itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].hovered = true;
        },

        dragLeave(itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].hovered = false;
        },

        submitForm() {
            const id = this.$route.params.id;

            this.loaded.submit = true;

            this.API.clients.connections.brands.update(id, this.submitData)
                .then(() => {
                    this.loaded.submit = false;

                    swal({
                        title: this.$translate.text('alert.success'),
                        text: this.$translate.text('alert.success.message.saved'),
                    });
                })
                .catch((error) => {
                    this.submittingIsLoading = false;
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

    },

    computed: {
        isLoaded() {
            return this.loaded.items.webshop && this.loaded.items.feed && this.loaded.items.combined;
        },

        submitData() {
            const submitData = {
                brands: {},
            };

            this.items.webshop.forEach(item => {
                item.placeholders.forEach(placeholder => {
                    if (placeholder.value.length > 0) {
                        if (!submitData.brands[item.id]) {
                            submitData.brands[item.id] = [];
                        }

                        submitData.brands[item.id].push(placeholder.value);
                    }
                });
            });

            return submitData;
        },

        combinableValues() {
            const combinable = this.items.webshop;

            if (this.search_combinable.length > 0) {
                return combinable.filter(value => value.name.toLowerCase().includes(this.search_combinable.toLowerCase()));
            }

            return combinable;
        },

        uncombinedValues() {
            const combined = [];

            this.items.webshop.forEach(item => {
                item.placeholders.forEach(placeholder => {
                    if (placeholder.value.length > 0) {
                        combined.push(placeholder.value);
                    }
                });
            });

            const filtered = this.items.feed.filter(value => !combined.includes(value));

            if (this.search.length > 0) {
                return filtered.filter(value => value.toLowerCase().includes(this.search.toLowerCase()));
            }

            return filtered;
        },
    },
};
</script>
<style lang="scss" scoped>
.n-m-t {
    margin-top: 0px;
}

.n-p {
    padding: 0px;
}

.m-w-190 {
    max-width: 190px;
}

.depth-line {
    border-left:1px dotted rgba(160, 179, 196, 0.4);
    position: absolute;
}

.ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.no-select {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select:none;
    user-select:none;
    -o-user-select:none;
}
</style>
